import React, { FC } from 'react';
import { UserFormDataType } from '@atlas-frontend/sdk';
import {
  SectionBreadcrumbs,
  SectionBreadcrumbsProps,
} from '../../common/SectionBreadcrumbs';
import { USER_ROUTES } from './Users';

export interface UserBreadcrumbsData {
  user?: UserFormDataType;
}

export type UserBreadcrumbsProps = Omit<
  SectionBreadcrumbsProps<UserBreadcrumbsData>,
  'routes'
>;

export const UserBreadcrumbs: FC<UserBreadcrumbsProps> = (props) => (
  <SectionBreadcrumbs {...props} routes={USER_ROUTES} />
);
